import { addMinutes, format } from "date-fns";

export function getUTCDate(date: Date, dateFormat: string = "yyyy-MM-dd"): string {
  const dateInUTC = addMinutes(date, date.getTimezoneOffset());

  return format(dateInUTC, dateFormat);
}